import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isSuccessCode } from '@/common/utils/response';
import { getMeetingCapability } from '@/common/http/meet';
import { setCapability } from '@/common/store/whole/slice';
import { setBookingMeetingType, setIsOpenBookingMeeting } from '@/common/store/booking/slice';
import { TField } from '@/common/basis/types/tfield';
import { TStore } from '@/common/basis/types/tstore';
import { openJoinroomUrl, openQuickRoomUrl } from '@/common/utils/window/webview';
import CheckBeforeJoin from '@/components/HOC/CheckBeforeJoin';

function App() {
  const dispatch = useDispatch();
  const liveStream = useSelector((state: TStore.State) => state.whole.capability?.liveStream);
  const { t } = useTranslation();

  const openBookingMeetingBtn = async (meetingType: TField.MeetingType) => {
    try {
      const resp = await getMeetingCapability();

      if (isSuccessCode(resp?.code)) {
        dispatch(setCapability(resp?.data));
      }
      dispatch(setIsOpenBookingMeeting(true));
      dispatch(setBookingMeetingType(meetingType));
    } catch (err) {
      // TODO
      dispatch(setIsOpenBookingMeeting(true));
      dispatch(setBookingMeetingType(meetingType));
    }
  };

  return (
    <>
      <div className='flex h-screen flex-col overflow-hidden'>
        <div className='absolute left-0 right-0 top-0 h-3 drag' />
        <div className='flex-1 border-0 border-r-[1px] border-solid border-r-[#f0f0f0] py-3 pt-0'>
          <div className='flex h-[59px] items-center justify-start border-0 border-b-[1px] border-solid border-b-[#f0f0f0]'>
            <span className='px-3 text-[16px] font-medium text-[#353535]'>{t('videoconferencing')}</span>
          </div>
          <div className='flex w-[264px] flex-wrap p-2'>
            <div className='relative mr-2 h-[70px] w-[120px] cursor-pointer overflow-hidden rounded-md bg-[rgba(79,198,126,.12)]'>
              <CheckBeforeJoin callback={(success) => success && openJoinroomUrl()}>
                <div className='m-2 h-7 w-7 overflow-hidden'>
                  <img
                    className='h-full w-full object-cover'
                    draggable='false'
                    src={require('@/common/basis/assets/join_meeting_icon_0.png')}
                  />
                </div>
                <div className='absolute bottom-0 left-0 right-0 flex h-8 items-center justify-end px-2'>
                  <span className='text-[12px] text-[#4fc67e]'>{t('joinMenu')}</span>
                </div>
              </CheckBeforeJoin>
            </div>
            <div className='relative h-[70px] w-[120px] cursor-pointer overflow-hidden rounded-md bg-[rgba(0,96,255,.07)]'>
              <CheckBeforeJoin callback={(success) => success && openQuickRoomUrl()}>
                <div className='m-2 h-7 w-7 overflow-hidden'>
                  <img
                    className='h-full w-full object-cover'
                    src={require('@/common/basis/assets/create_meeting_icon_0.png')}
                  />
                </div>
                <div className='absolute bottom-0 left-0 right-0 flex h-8 items-center justify-end px-2'>
                  <span className='text-[12px] text-[#0060ff]'>{t('quickMeeting')}</span>
                </div>
              </CheckBeforeJoin>
            </div>
            <div
              className='relative mr-2 mt-2 h-[70px] w-[120px] cursor-pointer overflow-hidden rounded-md bg-[rgba(253,164,80,.1)]'
              onClick={() => openBookingMeetingBtn(TField.MEETING_TYPE_BOOKING)}
            >
              <div className='m-2 h-7 w-7 overflow-hidden'>
                <img
                  className='h-full w-full object-cover'
                  src={require('@/common/basis/assets/booking_meeting_icon_0.png')}
                />
              </div>
              <div className='absolute bottom-0 left-0 right-0 flex h-8 items-center justify-end px-2'>
                <span className='text-[12px] text-[#fda450]'>{t('bookingMenu')}</span>
              </div>
            </div>
            {liveStream && (
              <div
                className='relative mt-2 h-[70px] w-[120px] cursor-pointer overflow-hidden rounded-md bg-[rgba(225,124,218,.12)]'
                onClick={() => {
                  openBookingMeetingBtn(TField.MEETING_TYPE_LIVE);
                }}
              >
                <div className='m-2 h-7 w-7 overflow-hidden'>
                  <img
                    className='h-full w-full object-cover'
                    src={require('@/common/basis/assets/live_meeting_icon_0.png')}
                  />
                </div>
                <div className='absolute bottom-0 left-0 right-0 flex h-8 items-center justify-end px-2'>
                  <span className='text-[12px] text-[#E17CDA]'>{t('liveStreaming')}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
